// extracted by mini-css-extract-plugin
module.exports = {"registros":"FunilVendas_registros__1x0IR","registro":"FunilVendas_registro__3ETAl","linkCarregarMais":"FunilVendas_linkCarregarMais__2Vr6R"};